import z from 'zod';
export const FIRM_PAYMENT_METHOD_TYPE_CARD = 'card';
export const FIRM_PAYMENT_METHOD_TYPE_CUSTOMER_BALANCE = 'customer_balance';
export const FIRM_PAYMENT_METHOD_TYPE_SEPA_DEBIT = 'sepa_debit';
export const firmPaymentMethodTypeValue = z.enum([
    FIRM_PAYMENT_METHOD_TYPE_CARD,
    FIRM_PAYMENT_METHOD_TYPE_CUSTOMER_BALANCE,
    FIRM_PAYMENT_METHOD_TYPE_SEPA_DEBIT,
]);
export const createFirmPaymentMethodType = (value) => firmPaymentMethodTypeValue.parse(value);
export const isFirmPaymentMethodType = (value) => firmPaymentMethodTypeValue.safeParse(value).success;
//# sourceMappingURL=firm-payment-method-type.js.map